import { GoogleAnalyticsEventContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const AnalyticsEventProvider = createStaticContextProvider(
  GoogleAnalyticsEventContext,
  lazyValue(() =>
    import("./analytics-event").then((module) => module.analyticsEvent),
  ),
);
